import "./App.css";
import AppRoute from "./routes/appRoute";

function App() {
  return (
    <div>
      <AppRoute />
    </div>
  );
}

export default App;
